"use strict";

(function () {
  var navContent = document.querySelector('.custom_navigation__content');
  var navSearchWrapper = document.querySelector('.navbar_search_wrapper');
  var searchField = document.getElementById('menu-search-field');
  var searchButton = document.getElementById('search__button');
  var searchClose = document.getElementById('search__close');
  var menuInner = document.querySelector('.custom_navigation__inner');
  var navItems = menuInner && menuInner.querySelectorAll('button, [role="button"]');
  var body = document.body;
  body.classList.add('custom-header');
  menuInner.addEventListener('focusin', function () {
    if (header.classList.contains('hidden-header')) {
      header.classList.remove('hidden-header');
      body.classList.remove('hidden-header');
    }
  }, true);
  var isMobile = function isMobile() {
    return window.innerWidth < 900;
  };
  var setMenu = function setMenu(el) {
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    navItems.forEach(function (prev) {
      var parent = prev.closest('.menu_item');
      var checks = parent && parent.querySelectorAll('.menu__checkbox');
      parent && parent.classList.remove('open');
      if (!show && checks) {
        checks.forEach(function (check) {
          return check.classList.remove('checked');
        });
        if (parent.classList.contains('search')) searchField.value = '';
      }
      prev.getAttribute('aria-expanded') && prev.setAttribute('aria-expanded', 'false');
    });
    if (show) {
      var parent = el.closest('.menu_item');
      parent.classList.add('open');
      el.setAttribute('aria-expanded', 'true');
    }
    el.focus();
  };
  var setSearchFieldWidth = function setSearchFieldWidth() {
    if (window.innerWidth < 1200) return;
    navSearchWrapper.style.width = searchButton.getBoundingClientRect().left - navContent.getBoundingClientRect().left + searchButton.offsetWidth + 'px';
  };
  var searchFocus = function searchFocus() {
    return searchField.focus();
  };
  if (searchButton && navSearchWrapper && searchClose) {
    document.addEventListener('readystatechange', function (e) {
      navSearchWrapper.style.visibility = 'hidden';
      if (e.target.readyState === 'complete') {
        setSearchFieldWidth();
        navSearchWrapper.style.removeProperty('visibility');
      }
    });
    if (searchField) {
      searchButton.addEventListener('click', function () {
        setSearchFieldWidth();
        setTimeout(function () {
          return searchFocus();
        }, 100);
      });
      searchField.addEventListener('blur', function () {
        if (searchField.value.length === 0) {
          searchClose.click();
        }
      });
      searchClose.addEventListener('click', function (e) {
        e.preventDefault();
        searchField.value = '';
        setMenu(searchButton);
        searchButton.focus();
      });
      searchButton.addEventListener('keydown', function (e) {
        return (e.key === ' ' || e.keyCode === KEYCODE_SPACE) && searchFocus();
      });
      searchClose.addEventListener('keydown', function (e) {
        e.preventDefault();
        (e.key === ' ' || e.keyCode === KEYCODE_SPACE) && searchClose.click();
      });
    }
    var _resetTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(_resetTimeout);
      _resetTimeout = setTimeout(setSearchFieldWidth, 50);
    });
  }

  // ============= On Scroll Header ===============
  var header = document.getElementById('custom-navigation-fixed');
  var isMenuOpened = document.getElementById('main-navigation-menu');
  var isLanguageMenuOpened = document.getElementById('language-menu-switch');
  var scrollPosition = 0;
  var getBodyRectTop = function getBodyRectTop() {
    return Math.round(body.getBoundingClientRect().top);
  };
  var getFirstVisibleComponentHeight = function getFirstVisibleComponentHeight() {
    return document.querySelector('main.main > .cp:not(.non-rendering)').clientHeight || 0;
  };
  var setScrollPosition = function setScrollPosition() {
    return scrollPosition = getBodyRectTop() <= 0 ? getBodyRectTop() : 0;
  };
  var onScroll = function onScroll() {
    if (window.innerWidth < 1200 && (isMenuOpened.classList.contains('checked') || isLanguageMenuOpened.classList.contains('checked'))) {
      setScrollPosition();
      return;
    }
    if (!header.contains(document.activeElement)) {
      if (getBodyRectTop() >= scrollPosition) {
        header.classList.remove('hidden-header');
        body.classList.remove('hidden-header');
      } else if (!body.classList.contains('overlay-visible')) {
        header.classList.add('hidden-header');
        body.classList.add('hidden-header');
      }
    }
    if (header.parentElement.classList.contains('custom_navigation--inverted')) {
      if (getBodyRectTop() + getFirstVisibleComponentHeight() - header.clientHeight >= 0) header.parentElement.classList.remove('scrolled-header');else header.parentElement.classList.add('scrolled-header');
    }
    setScrollPosition();
  };
  if (header) {
    var scrollTimeout;
    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(onScroll, 25);
    });
  }
  // ============= On Scroll Header END ===============

  var menuButton = document.querySelectorAll('.language__link, .menu__button');
  if (menuButton) {
    menuButton.forEach(function (button) {
      button.addEventListener('click', function () {
        if (window.innerWidth >= 1200) return;
        var menuOpened = document.querySelectorAll('.menu__checkbox.checked');
        menuOpened.length && menuOpened.forEach(function (check) {
          return check.id !== button.dataset.checkboxLabelFor && check.classList.remove('checked');
        });
      });
    });
  }
  var resetTimeout;
  var docHeight = function docHeight() {
    return document.documentElement.style.setProperty('--doc-height', "".concat(window.innerHeight, "px"));
  };
  var resetHeight = function resetHeight() {
    clearTimeout(resetTimeout);
    resetTimeout = setTimeout(docHeight, 50);
  };
  docHeight();
  document.addEventListener('readystatechange', function (e) {
    return e.target.readyState === 'complete' && docHeight();
  });
  window.addEventListener('resize', resetHeight);
  window.addEventListener('orientationchange', resetHeight);
  if (navItems.length) {
    navItems.forEach(function (item) {
      if (item.getAttribute('aria-expanded')) {
        var parent = item.closest('.menu_item');
        menuFocusTrap(parent);
        'keydown click'.split(' ').forEach(function (type) {
          return item.addEventListener(type, function (e) {
            if (e.key === ' ' || e.keyCode === KEYCODE_SPACE || type === 'click') {
              navItems.forEach(function (iItem) {
                if (iItem !== item) {
                  setMenu(iItem);
                }
              });
              setMenu(item, !parent.classList.contains('open'));
              console.log(type + 'fired');
            }
          }, false);
        });
        'keyup mouseout'.split(' ').forEach(function (type) {
          return parent.addEventListener(type, function (e) {
            var _searchField$value;
            if (isMobile()) return;
            if ((parent.classList.contains('search') || searchField !== null && searchField !== void 0 && (_searchField$value = searchField.value) !== null && _searchField$value !== void 0 && _searchField$value.length) && (type === 'mouseout' || type === 'keyup')) return;
            if (e.key === 'Escape' || e.keyCode === KEYCODE_ESC || e.key === 'ArrowUp' || type === 'mouseout') setMenu(item);
          });
        });
      }
    });
    menuInner && menuInner.focus();
  }
})();
var KEYCODE_TAB = 9;
var KEYCODE_ENTER = 13;
var KEYCODE_ESC = 27;
var KEYCODE_SPACE = 32;
function menuFocusTrap(element) {
  var focusable = element.querySelectorAll('a, button, [role="button"][aria-haspopup="true"], input[type="text"]:not([disabled])');
  var first = focusable[1];
  var last = focusable[focusable.length - 1];
  focusable && focusable.forEach(function (el) {
    el.addEventListener('keydown', function (e) {
      return (e.key === 'Enter' || e.keyCode === KEYCODE_ENTER) && e.target.click();
    });
  });
  element.addEventListener('keydown', function (e) {
    var isTab = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTab || focusable.length === 1) return;
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus(); /* shift + tab */
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus(); /* tab */
    }
  });
  element.addEventListener('keyup', function () {
    return document.activeElement === focusable[0] && focusable[0].getAttribute('aria-expanded') === 'true' && focusable[1].focus();
  });
}